import { render, staticRenderFns } from "./nimei-program.vue?vue&type=template&id=68d133e0&scoped=true"
import script from "./nimei-program.vue?vue&type=script&lang=js"
export * from "./nimei-program.vue?vue&type=script&lang=js"
import style0 from "./nimei-program.vue?vue&type=style&index=0&id=68d133e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d133e0",
  null
  
)

export default component.exports